import * as React from 'react'
import { useAppSelector } from '../../../../reducers'
import { useAppDispatch } from '../../../../actions/types'
import * as DeviceActions from '../../../../actions/device'
import * as DeviceSelectors from '../../../../reducers/device'
import Device from '../../../../types/DeviceMain'

interface StoreOption {
    key: string;
    value: string;
}

interface UseDisplayStoresProps {
    currentValues: string[];
    search?: string;
}


export default function useDisplayDevices({ currentValues = [], search = ''}: UseDisplayStoresProps): StoreOption[] {
    const dispatch = useAppDispatch()
    const devices = useAppSelector<Device[]>(state => DeviceSelectors.selectDevicesList(state) ?? [])

    React.useEffect(() => {
        if (search.length > 6) {
            dispatch(DeviceActions.fetchDevices({ search }))
        } else {
            dispatch(DeviceActions.clearDevicesList())
        }
    }, [dispatch, search])    

    return React.useMemo(() => {
        const lowerSearch = search.toLowerCase()

        return devices.filter(device => {
            const alreadyIncluded = currentValues.includes(device.id)
            const matchesPartialSearch = device.id.toLowerCase().includes(lowerSearch)

            return !alreadyIncluded && matchesPartialSearch
        }).sort((a, b) => {
            return a.id.localeCompare(b.id)
        }).map((device) => ({
            key: device.id,
            value: device.id,
        }))
    }, [currentValues, devices, search])
}
